var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivities(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#746780",
    d: "M4.147 14.995a.75.75 0 110 1.5.75.75 0 010-1.5zm9.348-5a3.88 3.88 0 00-3.875 3.876 3.88 3.88 0 003.875 3.876 3.88 3.88 0 003.876-3.876 3.88 3.88 0 00-3.876-3.876zm-9.348-.998a.75.75 0 110 1.5.75.75 0 010-1.5zm9.348-.411a5.29 5.29 0 015.286 5.285 5.258 5.258 0 01-1.052 3.16l-.006.007 5.683 5.682a.749.749 0 11-1.06 1.06L16.662 18.1l-.007.005a5.258 5.258 0 01-3.16 1.052A5.29 5.29 0 018.21 13.87a5.29 5.29 0 015.285-5.285zm-9.348-5.61a.75.75 0 110 1.5.75.75 0 010-1.5zM1.874 1.5v4.498h15.745V1.5zM1.124 0H18.37a.75.75 0 01.75.75V9.93a6.904 6.904 0 00-1.5-1.546v-.887H1.874v4.498h5.015a6.82 6.82 0 00-.247 1.5H1.874v4.498H8.01c.005.008.013.014.018.021v1.479H1.124a.75.75 0 01-.75-.75V.75a.75.75 0 01.75-.75z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default ForwardRef;